/**
 * Make a JSON string safe to put inside an inline `<script>` element (a JSON-LD block, the
 * dehydrated query cache): `<` is escaped so no data can ever close the tag or open a comment, and
 * U+2028 / U+2029 are escaped because they are line terminators in JavaScript source.
 *
 * Dependency-free on purpose: the build step (`prerender/html.ts`) and the app both use it.
 */
const LINE_SEPARATOR = new RegExp(String.fromCharCode(0x2028), 'g');
const PARAGRAPH_SEPARATOR = new RegExp(String.fromCharCode(0x2029), 'g');
const BACKSLASH = String.fromCharCode(92);

export function escapeScriptJson(json: string): string {
  return json
    .replace(/</g, `${BACKSLASH}u003c`)
    .replace(LINE_SEPARATOR, `${BACKSLASH}u2028`)
    .replace(PARAGRAPH_SEPARATOR, `${BACKSLASH}u2029`);
}
